import { AxiosInstance } from "axios";
import { IResponseBody } from "../../Schemas/EndPoint";
import { WorkspaceSchema } from "../../Schemas/Workspace";

export interface WorkspaceCreateResponseBody extends IResponseBody {
  data: WorkspaceSchema;
}

export interface WorkspaceCreateRequestBody {
  name: string;
}

export class WorkspaceCreateRequest {
  private protectedAxiosInstance: AxiosInstance;
  private path = `/panel/workspaces/create`;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  async send(
    workspaceReqBody: WorkspaceCreateRequestBody
  ): Promise<WorkspaceCreateResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.path,
        workspaceReqBody
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
